import * as actions from 'modules/actions';
import { createReducer } from 'redux-act';
import { IHelpItem } from 'modules/types';

export interface IPrizesReducer {
	items: IHelpItem[];
}

const defaultState = {
	items: []
};

export const prizes = createReducer<IPrizesReducer>({}, defaultState)
	.on(actions.fetchPrizesSuccess, (state, result) => ({
		...state,
		items: result
	}));
